let baseUrl = '',
	imgBaseUrl = '',
	videoBaseUrl = ''

if (process.env.NODE_ENV == 'development') {
	// baseUrl = 'http://ls2020.qicp.vip/api/'
	baseUrl = 'https://www.ddfddf.com/api/'
	imgBaseUrl = 'https://ddfchinanew-1310653466.cos.ap-guangzhou.myqcloud.com/'
	videoBaseUrl = 'https://designv.oss-cn-beijing.aliyuncs.com/'
} else if (process.env.NODE_ENV == 'production') {
	baseUrl = 'https://www.ddfddf.com/api/'
	imgBaseUrl = 'https://ddfchinanew-1310653466.cos.ap-guangzhou.myqcloud.com/'
	videoBaseUrl = 'https://designv.oss-cn-beijing.aliyuncs.com/'
}

export {
	baseUrl,
	imgBaseUrl,
	videoBaseUrl
}